import TriggersIcon from "./TriggersIcon";
import EditIcon from "./EditIcon";
import AccessControlIcon from "./AccessControlIcon";
import ActionIcon from "./ActionIcon";
import NetworkOfficeIcon from "./NetworkOfficeIcon";
import ResetPasscodeIcon from "./ResetPasscodeIcon";
import GatewayIcon from "./GatewayIcon";
import PerimeterIcon from "./PerimeterIcon";
import PerimeterStrictIcon from "./PerimeterStrictIcon";
import WifiIcon from "./WifiIcon";
import ViewIcon from "./ViewIcon";
import BigHelpIcon from "./BigHelpIcon";
import UserAuthIcon from "./UserAuthIcon";
import NetworkingAdminIcon from "./NetworkingAdminIcon";
import LoggingAndStatusIcon from "./LoggingAndStatusIcon";
import ManagementIcon from "./ManagementIcon";
import EndUserIcon from "./EndUserIcon";
import HorizontalDotsIcon from "./HorizontalDotsIcon";
import MinimizeViewIcon from "./MinimizeViewIcon";
import UnderMaintenanceIcon from "./UnderMaintenanceIcon";
import CollapseAllIcon from "./CollapseAllIcon"
import ExpandAllIcon from "./ExpandAllIcon"
import PlusButtonIcon from "./PlusButtonIcon"
import LoginArrowIcon from "./LoginArrowIcon"

export default {
  "access-control": AccessControlIcon,
  edit: EditIcon,
  triggers: TriggersIcon,
  action: ActionIcon,
  "network-office,company": NetworkOfficeIcon,
  "reset-passcode,tokens": ResetPasscodeIcon,
  gateway: GatewayIcon,
  management: ManagementIcon,
  enduser: EndUserIcon,
  perimeter: PerimeterIcon,
  "perimeter-strict,perimeter strict": PerimeterStrictIcon,
  wifi: WifiIcon,
  big_help: BigHelpIcon,
  logging_and_status: LoggingAndStatusIcon,
  networking_admin: NetworkingAdminIcon,
  user_auth: UserAuthIcon,
  "horizontal-dots,toolbar-more": HorizontalDotsIcon,
  "minimize-view,minus": MinimizeViewIcon,
  "maintenance,under-maintenance": UnderMaintenanceIcon,
  "view": ViewIcon,
  "expand-all": ExpandAllIcon,
  "collapse-all": CollapseAllIcon,
  "plus-button": PlusButtonIcon,
  "login-arrow": LoginArrowIcon,
};
